export default {
  financeiro: {
    financeiro: 'Financiero',
    razaoSocial: 'Razón social',
    nomeFantasia: 'Nombre fantasía',
    cnpj: 'CNPJ',
    telefone: 'Teléfono',
    email: 'E-mail',
    planosDeAcesso: 'Plano de acceso',
    produtoresAtivos: 'Productores activos',
    motivo: 'Motivo de la inactivación',
    dataInativacao: 'Fecha de inactividad',
    dataCadastro: 'Fecha de registro',
    ativo: 'Activo',
    inativo: 'Inactivo',
    endereco: 'Dirección',
    contatosAdicionais: 'Contactos adicionales',
    usuarios: 'Usuarios',
    identificacao: 'Identificación',
    cep: 'CEP',
    estado: 'Estado',
    cidade: 'Ciudad',
    rua: 'Calle',
    numero: 'Número',
    complemento: 'Complemento',
    bairro: 'Barrio',
    departamento: 'Departamento',
    nome: 'Nombre',
    perfil: 'Perfil',
    statusConta: 'Estado de cuenta',
    situacao: 'Situación',
    identificacaoFinanceiro: 'Identificación',
    cadastroFinanceiro: 'Registro de financeiro',
    gravar: 'Registro',
    salvar: 'Guardar',
    cancelar: 'Cancelar',
    reenviarCodigo: 'Reenviar el correo electrónico de activación',
    principal: 'Principal',
    entregas: 'Entregas',
    administrativo: 'Administrativo',
    gerencia: 'Administración',
    ti: 'T.I.',
    tecnico: 'Técnico',
    revenda: 'Reventa',
    campoObrigatorio: 'Campo obligatorio',
    emailInvalido: 'Correo electrónico no válido',
    carregando: 'Carga',
    financeiroCadastrado: 'Financeiro registrado con éxito',
    financeiroEditado: 'Financeiro actualizado con éxito',
    sucesso: 'Éxito',
    erro: 'Error',
    usuarioJaCadastrado: 'Usuario ya registrado',
    registrado: 'Registrado',
    confirmado: 'Confirmado',
    desabilitado: 'Discapacitado',
    admin: 'Administrador',
    salvando: 'Ahorro',
    atualizando: 'Actualización',
    usuarioJaCadastradoTabela: 'No se pudo insertar el usuario',
    naoFoiPossivelInserirUsuario:
      'Este usuario ya ha sido registrado en el sistema',
    naoFoiPossivelInserirEditar:
      'Este usuario ya ha sido editado en el sistema',
    erroCadastroUsuario: 'Error al registrar usuario',
    usuarioCadastradoComSucesso: 'Usuario registrado con éxito',
    financeiroCadastradoComSucesso: 'Financeiro registrado con éxito',
    usuariosNaoCadastrados:
      'Lamento, no fue posible registrar los siguientes usuarios:',
    financeiroEditadoComSucesso: 'Financeiro editado con éxito',
    preRegistro: 'Pre-registro',
    produtor: 'Produtor',
    falhaAoCarregarFinanceiro: 'Error al cargar financeiro',
    numeroMaximoUsuarios: 'Se ha alcanzado el límite de usuarios de este plan',
    excluir: 'Borrar',
    excluindo: 'Excluyendo',
    desejaExcluir: '¿Desea eliminar?',
    nao: 'No',
    financeiroExcluidoComSucesso: 'Financeiro excluido con éxito',
    falhaAoExcluirFinanceiro: 'Error al excluir financeiro',
    usuarioExcluidoComSucesso: 'Usuario eliminado con éxito',
    plano: 'Plan',
    telefoneInvalido: 'Teléfono no válido',
    cnpjInvalido: 'CNPJ no válido',
    cepInvalido: 'CEP no válido',
    desejaExcluirEndereco: '¿Desea eliminar la dirección?',
    desejaExcluirContatosAdicionais: '¿Desea eliminar contacto adicional?',
    erroAoReenviarEmail: 'Error al reenviar correo electrónico',
    codigoEnviadoComSucesso: 'Código enviado con éxito',
    pais: 'País',
    cadastrarPais: 'Primer registro del país',
    cnpjDuplicado: 'CNPJ ya registrado',
    erroAoEditar: 'Se produjo un error al modificar el financeiro',
    erroBuscarFinanceiro: 'Se produjo un error al buscar financeiro',
    emailDuplicado: 'Correo electrónico ya está registrado',
    valorImplantacao: 'Valor de la implementación',
    valorLicenciamento: 'Valor de licencia',
    terminoVigencia: 'Término de vigencia',
    inicioVigencia: 'Inicio de la vigencia',
    vlMensalidade: 'Valor de la mensualidad',
    recorencia: 'Reaparición',
    recorrenciaRemovidoComSucesso: 'Recurrencia removida con éxito',
    falhaAoCadastrarFinanceiro: 'Error al corregir financiero',
    dataRecorrenciaInvalida: 'Fecha de la recurrencia no disponible',
    nrProdutor: 'Número de productores',
    nrTecnico: 'Número de técnicos',
    ilimitado: 'Ilimitado',
    quantidadeMinima: 'La cantidad mínima es 1',
    dataMinima: 'Fecha inválida',
    confirmar: 'Confirmar',
    salvarFinanceiroSair:
      'Hay información no guardada, ¿desea guardar información financiera?',
    descartar: 'Descartar',
    nrNdvi: 'Área de hectáreas NDVI',
    habilitarNdvi: 'Enable NDVI'
  }
};
